import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './assets/css/tailwind.css'
import './assets/css/components.css'
import './assets/css/global.css'
import './assets/css/reset.css'
// import "./utils/autoZoom";

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)